import React, { FC } from 'react';
import { WithStyle } from '../../utils/with-style';
import HeadingStyled from './heading.styled';
import HeadingProps from './types';

export const Heading: FC<HeadingProps> & WithStyle = props => <HeadingStyled {...props} />;

Heading.defaultProps = {
  $size: 'h1',
  $color: 'primary',
  $align: 'left',
  children: 'Heading',
  as: 'h1',
  oneRow: false,
};

Heading.displayName = 'Heading';
Heading.Style = HeadingStyled;
